import { ErrorPipe } from './../pipes/error.pipe';
import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from '../services/misc/logger.service';
import { DialogService } from '../services/ux/dialog.service';

@Injectable()
export class MainErrorHandler implements ErrorHandler {
  constructor(
    private dialogService: DialogService,
    private logger: LoggerService
  ) {
  }

  async handleError(error) {
    if (error && error.promise) {
      error = error.rejection;
    }

    if (error !== undefined) {
      this.logger.error(error);
      const message = ErrorPipe.extractMessageFromError(error);

      /** @todo Check why this error is being throwed */
      if (message === "Failed to fetch") {
        return;
      }

      this.dialogService.error(message);
    }
  }
}
